import { Injectable } from '@angular/core';
import { CustomFieldConfig } from './models/customFieldConfig';
import { CustomField } from './models';

import { configs } from 'src/assets/config/custom-fields';

@Injectable({
  providedIn: 'root',
})
export class CustomFieldsService {
  private config: CustomFieldConfig;

  public loadCustomFieldConfigForApplication(applicationType: string) {
    this.config = configs.find(c => c.applicationType === applicationType);
  }

  public getSection(applicationSection: string): CustomField[] {
    return this.config?.fields.filter(f => f.section === applicationSection) ?? [];
  }
}
